@if (isLoading()) {
  <div class="bg-white border d-flex flex-column mh-100 overflow-hidden rounded-4 shadow-sm">
    <div class="d-flex align-items-center p-3">
      <p-skeleton width="15rem" height="1.75rem"></p-skeleton>
    </div>
    <div class="p-2 mh-100 d-flex flex-column gap-3 flex-fill overflow-y-auto">
      <!-- Approvals Section Skeleton -->
      <div class="bg-light p-3 rounded-4">
        <div class="d-flex align-items-center gap-2 mb-3">
          <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
          <p-skeleton width="8rem" height="1.25rem"></p-skeleton>
        </div>

        <div class="d-flex flex-column gap-3">
          <!-- Buyer Approved Skeleton -->
          <div>
            <div class="d-flex align-items-center mb-2">
              <p-skeleton width="10rem" height="1rem"></p-skeleton>
              <div class="ms-auto">
                <p-skeleton width="3rem" height="1.5rem" borderRadius="1rem"></p-skeleton>
              </div>
            </div>
          </div>

          <!-- Builder Approved Skeleton -->
          <div>
            <div class="d-flex align-items-center mb-2">
              <p-skeleton width="10rem" height="1rem"></p-skeleton>
              <div class="ms-auto">
                <p-skeleton width="3rem" height="1.5rem" borderRadius="1rem"></p-skeleton>
              </div>
            </div>
            <p-skeleton width="20rem" height="1.5rem" borderRadius="0.5rem"></p-skeleton>
          </div>
        </div>
      </div>

      <!-- Addendum Details Section Skeleton -->
      <div class="bg-light p-3 rounded-4">
        <div class="d-flex align-items-center gap-2 mb-3">
          <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
          <p-skeleton width="12rem" height="1.25rem"></p-skeleton>
        </div>

        <!-- Builder Reference Skeleton -->
        <div class="mb-3">
          <p-skeleton width="10rem" height="1rem" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="100%" height="2.5rem" borderRadius="0.375rem"></p-skeleton>
        </div>

        <!-- Toggle Switches Skeleton -->
        <div class="mb-3">
          <div class="d-flex align-items-center mb-2">
            <p-skeleton width="7rem" height="1rem"></p-skeleton>
            <div class="ms-auto">
              <p-skeleton width="3rem" height="1.5rem" borderRadius="1rem"></p-skeleton>
            </div>
          </div>
          <div class="d-flex align-items-center">
            <p-skeleton width="5rem" height="1rem"></p-skeleton>
            <div class="ms-auto">
              <p-skeleton width="3rem" height="1.5rem" borderRadius="1rem"></p-skeleton>
            </div>
          </div>
        </div>

        <!-- Addendum Notes Skeleton -->
        <div class="mb-3">
          <p-skeleton width="10rem" height="1rem" styleClass="mb-2"></p-skeleton>
          <p-skeleton width="100%" height="6rem" borderRadius="0.375rem"></p-skeleton>
        </div>

        <!-- Save Button Skeleton -->
        <div class="d-flex justify-content-center">
          <p-skeleton width="10rem" height="2.5rem" borderRadius="0.375rem" styleClass="ms-auto"></p-skeleton>
        </div>
      </div>
    </div>
  </div>
} @else {
  <div class="bg-white border d-flex flex-column mh-100 overflow-hidden rounded-4 shadow-sm">
    <div class="d-flex align-items-center p-3">
      <h2 class="fs-20 mb-0">#{{ dealAddendum().seq }} {{ dealAddendum().builderReference.reference }}</h2>
    </div>
    <form
      class="p-2 mh-100 d-flex flex-column gap-3 flex-fill overflow-y-auto"
      [formGroup]="addendumForm"
      (ngSubmit)="updateAddendum()"
    >
      <div class="bg-light p-3 rounded-4">
        <div class="d-flex align-items-center gap-2" appBtnLoader="deal-approvals">
          <i class="bi bi-check-circle"></i>
          <h3 class="mb-0 fs-18">Approvals</h3>
          @if (dealAddendum().products.length === 0) {
            <i
              class="bi bi-exclamation-circle fs-14 lh-1 text-danger"
              ngbTooltip="Cannot approve an empty addendum."
              placement="bottom"
            ></i>
          }
        </div>
        @if (dealAddendum().isCancelled || dealCancelled()) {
          <div class="d-flex flex-column gap-2 mt-3">
            @if (!hideBuyerApproved()) {
              <div>
                <div class="d-flex">
                  <div class="d-flex flex-column">
                    <span class="fw-500 fs-14"> Buyer Approved </span>
                    @if (dealAddendum().buyerApproved && dealAddendum().buyerApprovedDate) {
                      <span class="align-items-center fw-500 gap-1 text-success d-inline-flex mb-2 p-0 fs-12">
                        Approved: {{ dealAddendum().buyerApprovedDate | date: 'MMM d, y, h:mm a' }}
                      </span>
                    }
                  </div>
                  <p-toggleswitch
                    [ngModel]="buyerApproved()"
                    [ngModelOptions]="{ standalone: true }"
                    class="text-nowrap ms-auto"
                    [disabled]="true"
                  />
                </div>
              </div>
            }

            <div>
              <div class="d-flex">
                <div class="d-flex flex-column">
                  <span class="fw-500 fs-14"> Builder Approved </span>
                  @if (dealAddendum().builderApproved && dealAddendum().builderApprovedDate) {
                    <span class="align-items-center fw-500 gap-1 text-success d-inline-flex fs-12 p-0">
                      Approved: {{ dealAddendum().builderApprovedDate | date: 'MMM d, y, h:mm a' }}
                    </span>
                  }
                </div>

                <p-toggleswitch
                  [ngModel]="builderApproved()"
                  [ngModelOptions]="{ standalone: true }"
                  class="text-nowrap ms-auto"
                  [disabled]="true"
                />
              </div>
            </div>
          </div>
        } @else {
          <div class="d-flex flex-column gap-2 mt-3">
            @if (!hideBuyerApproved()) {
              <div>
                <div class="d-flex">
                  <div class="d-flex flex-column">
                    <span class="fw-500 fs-14"> Buyer Approved </span>
                    @if (dealAddendum().buyerApproved && dealAddendum().buyerApprovedDate) {
                      <span class="align-items-center fw-500 gap-1 text-success d-inline-flex mb-2 p-0 fs-12">
                        Approved: {{ dealAddendum().buyerApprovedDate | date: 'MMM d, y, h:mm a' }}
                      </span>
                    }
                    @if (dealAddendum().products.length === 0) {
                      <span class="align-items-center fw-500 gap-1 text-danger d-inline-flex mb-2 p-0 fs-12">
                        Cannot approve an empty addendum.
                      </span>
                    }
                  </div>

                  @if (dealAddendum().products.length === 0 || isLockedAndNotSuperAdmin() || !canWriteDeals()) {
                    <p-toggleswitch
                      [ngModel]="buyerApproved()"
                      [ngModelOptions]="{ standalone: true }"
                      class="text-nowrap ms-auto"
                      [disabled]="true"
                    />
                  } @else {
                    <p-toggleswitch
                      class="text-nowrap ms-auto"
                      [ngModel]="buyerApproved()"
                      [ngModelOptions]="{ standalone: true }"
                      (onChange)="updateBuyerApproval($event.checked)"
                    />
                  }
                </div>
              </div>
            }

            <div>
              <div class="d-flex">
                <div class="d-flex flex-column">
                  <span class="fw-500 fs-14">
                    Builder Approved
                    @if (
                      dealAddendum().addendumType.name === AddendumType.INI && !isUnderContract() && !builderApproved()
                    ) {
                      <i
                        class="bi bi-exclamation-circle fs-14 lh-1 text-danger ms-1"
                        ngbTooltip="Contract is pending. You cannot approve this addendum as builder yet."
                      ></i>
                    }
                  </span>
                  @if (dealAddendum().builderApproved && dealAddendum().builderApprovedDate) {
                    <span class="align-items-center fw-500 gap-1 text-success d-inline-flex fs-12 p-0">
                      Approved: {{ dealAddendum().builderApprovedDate | date: 'MMM d, y, h:mm a' }}
                    </span>
                  }
                </div>

                @if (
                  dealAddendum().products.length === 0 ||
                  !canWriteDeals() ||
                  (!isSuperAdminUser() &&
                    (isLockedAndNotSuperAdmin() ||
                      (dealAddendum().addendumType.name === AddendumType.INI &&
                        !isUnderContract() &&
                        !builderApproved())))
                ) {
                  <p-toggleswitch
                    [ngModel]="builderApproved()"
                    [ngModelOptions]="{ standalone: true }"
                    class="text-nowrap ms-auto"
                    [disabled]="true"
                  />
                } @else {
                  <p-toggleswitch
                    class="text-nowrap ms-auto"
                    [ngModel]="builderApproved()"
                    [ngModelOptions]="{ standalone: true }"
                    (onChange)="updateBuilderApproval($event.checked)"
                  />
                }
              </div>
              <!-- @if (dealAddendum().addendumType.name === AddendumType.INI && !isUnderContract() && !builderApproved()) {
              <p-message severity="warn" styleClass="mt-2 w-100" size="small"
                >Contract is pending. You cannot approve this addendum as builder yet.</p-message
              >
            } -->

              @if (dealAddendum().builderApproved && !dealAddendum().builderApprovedDate) {
                <p-message severity="warn" styleClass="mt-2 w-100" size="small">
                  >Builder approval date is required to proceed with approvals.</p-message
                >
              }
            </div>
          </div>
        }
      </div>

      <div class="bg-light p-3 rounded-4">
        <div class="d-flex align-items-center gap-2 mb-3">
          <i class="bi bi-file-earmark-text"></i>
          <h3 class="mb-0 fs-18">Addendum Details</h3>
        </div>
        <!-- <div class="mb-3">
        <label class="form-label">Sequence Number</label>
        <input type="text" class="form-control" [value]="addendum()?.seq ?? ''" readonly disabled />
      </div> -->

        <div class="mb-3">
          <label class="form-label">Builder Reference</label>
          <generic-dropdown
            class="w-100"
            placeholder="Select Builder Reference"
            [allowSearch]="true"
            [items]="builderReferences()"
            [disabled]="isLocked()"
            formControlName="builderReferenceId"
          />
        </div>
        <div class="mb-2">
          <div class="d-flex align-items-center mb-2">
            <span class="fw-500 fs-14 me-auto">In Contract</span>
            <p-toggleswitch [disabled]="isLocked()" formControlName="inContract" />
          </div>
          <div class="d-flex align-items-center mb-2">
            <span class="fw-500 fs-14 me-auto">Cash</span>
            <p-toggleswitch [disabled]="isLocked()" formControlName="cash" />
          </div>
          <div class="d-flex align-items-center mb-2">
            <span class="fw-500 fs-14 me-auto">Include in APS</span>
            <p-toggleswitch
              [disabled]="isLocked() && !canChangeLockedIncludeInAps()"
              formControlName="includeInAps"
              (onChange)="updateLockedIncludeInAps($event.checked)"
            />
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label">Addendum Notes</label>
          <textarea
            pTextarea
            rows="4"
            class="form-control flex-fill rounded-4"
            placeholder="Add Notes"
            [disabled]="isLocked()"
            formControlName="notes"
          ></textarea>
        </div>
        <div class="d-flex justify-content-center">
          <!-- <button class="btn btn-primary btn-h42 w-100 mt-auto w-auto ms-auto" type="submit"></button> -->
          @if (canWriteDeals()) {
            <button
              [disabled]="isLocked()"
              class="btn btn-primary w-100 justify-content-center btn-h35"
              type="submit"
              appBtnLoader="deal-save-addendum-details"
            >
              Save Details
            </button>
          }
        </div>
      </div>

      <div class="bg-light p-3 rounded-4">
        <div class="d-flex align-items-center gap-2">
          <i class="bi bi-receipt-cutoff"></i>
          <h3 class="mb-0 fs-18">Cost Breakdown</h3>
        </div>

        <div class="d-flex flex-column gap-1 mt-2">
          <div class="d-flex flex-column gap-2">
            <div class="d-flex align-items-center justify-content-between">
              <span>Options</span>
              <span class="">{{ dealAddendum().optionsTotal | currencyFormat }}</span>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <span>Taxes</span>
              <span class="">{{ dealAddendum().taxesTotal | currencyFormat }}</span>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <span class="text-success fw-500"><i class="bi bi-tag fs-14 me-2"></i>Discounts</span>
              <span class="text-success fw-500">- {{ dealAddendum().discountsTotal | currencyFormat }}</span>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <span class="text-success fw-500"><i class="bi bi-gift fs-14 me-2"></i>Incentives</span>
              <span class="text-success fw-500">- {{ dealAddendum().incentivesTotal | currencyFormat }}</span>
            </div>
          </div>
          <hr />
          <div class="d-flex align-items-center justify-content-between">
            <span class="fw-500 fs-20 text-black">Total</span>
            <span class="fw-500 fs-24 text-black">{{ dealAddendum().total | currencyFormat }}</span>
          </div>
        </div>
      </div>
    </form>
  </div>
}
